<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Müşteri</div>
                <div slot="actions">
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Kullanıcı bilgileri yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-row class="mr-1 ml-1">
                        <v-col cols="12" md="6">
							<div class="text-center"><b>Hesap Bilgileri</b></div>
                            <v-row>
								<v-col cols="12" md="6">
									<v-text-field label="Adı" v-model="item.firstname" outlined hide-details placeholder="Örn: Ahmet"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field label="Soyadı" v-model="item.lastname" outlined hide-details placeholder="Örn: YESEVİ"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field label="GSM No" v-model="item.phone" outlined hide-details placeholder="Örn: 0555 452 55 55"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field label="Email" v-model="item.email" outlined hide-details placeholder="Örn: admin@firma.com.tr" autocomplete="off"></v-text-field>
								</v-col>
								<v-col cols="12" md="6"> 
<v-text-field 
            :append-icon="showPassword ? mdiEye : mdiEyeOff"
            :type="showPassword ? 'text' : 'password'" 
            label="Şifre" v-model="item.password" outlined hide-details
			autocomplete="off"
            @click:append="showPassword = !showPassword"
          ></v-text-field>


									<v-checkbox class="ma-0" color="red" v-model="item.changePassword" label="Şifreyi değiştir" ></v-checkbox>
								</v-col>
								<v-col cols="12" md="6"> 
									<v-checkbox color="green" v-model="item.active" label="Bu hesap aktifir" ></v-checkbox>
								</v-col>
							</v-row>
                        </v-col>

                        <v-col cols="12" md="6">
							<div class="text-center"><b>Firma Bilgileri</b></div>
                            <v-row>
								<v-col cols="12">
									<v-text-field label="FİRMA ADI" v-model="item.company.firma_adi" outlined hide-details ></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field label="FİRMA ADRESİ" v-model="item.company.firma_adresi" outlined hide-details ></v-text-field>
								</v-col>
								<v-col cols="6" md="4">
									<v-text-field label="İL" v-model="item.company.il" outlined hide-details ></v-text-field>
								</v-col>
								<v-col cols="6" md="4">
									<v-text-field label="İLÇE" v-model="item.company.ilce" outlined hide-details ></v-text-field>
								</v-col>
								<v-col cols="6" md="4">
									<v-text-field label="Vergi No" v-model="item.company.vergi_no" outlined hide-details ></v-text-field>
								</v-col>
							</v-row>
                        </v-col>


						<v-col cols="12">
							<v-divider></v-divider> 
						</v-col>

						<v-col cols="12">
							<div class="text-center"><b>Firma Yetkilileri</b></div>
							

                    <table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr>
                                <th width="1px">No</th>
                                <th width="200px">Adı</th>
                                <th width="200px">Soyadı</th>
                                <th>Departman</th>
                                <th width="200px">EMail</th>
                                <th width="160px">GSM</th> 
                                <th width="1px" class="actions"></th>
                                <th width="1px" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(subuser, subuserIndex) in item.subusers" :key="subuserIndex">
                                <td>12</td>
                                <td class="cell-detail"> 
									<v-text-field :label="_label_author_name" v-model="subuser.firstname" outlined dense hide-details background-color="white" ></v-text-field>
                                </td>
                                <td class="cell-detail"> 
									<v-text-field :label="_label_author_name" v-model="subuser.lastname" outlined dense hide-details background-color="white" ></v-text-field>
                                </td>
                                <td class="cell-detail"> 
									<v-text-field :label="_label_author_name" v-model="subuser.department" outlined dense hide-details background-color="white" ></v-text-field>
                                </td>
                                <td class="cell-detail"> 
									<v-text-field :label="_label_author_name" v-model="subuser.email" outlined dense hide-details background-color="white" ></v-text-field>
                                </td>
                                <td class="cell-detail"> 
									<v-text-field :label="_label_author_name" v-model="subuser.phone" outlined dense hide-details background-color="white" ></v-text-field>
                                </td> 
                                <td class="actions">
                                    <v-btn small icon color="primary" dark v-on:click.stop.prevent="addSubuser(subuserIndex)">
                                        <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                    </v-btn>
                                </td>
                                <td class="actions">
                                    <v-btn small icon color="red" dark v-on:click.stop.prevent="removeItem(subuserIndex)">
                                        <v-icon>{{mdiCloseCircle}}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="text-center mb-4">
                        <v-btn tile color="green" dark v-on:click.stop.prevent="addSubuser()">
                            <v-icon>{{mdiPlus}}</v-icon> Yeni Satır Ekle
                        </v-btn>
                    </div>
						</v-col>

                    </v-row>

 
                </template>
            </panelcontainer>


    <v-snackbar
      v-model="actionDialogShow" 
      :color="actionDialogColor"   
      :timeout="3000"
      top 
    >
      {{ actionDialogText }}
      <v-btn
        dark
        text
        @click="actionDialogShow = false"
      >
        Tamam
      </v-btn>
    </v-snackbar>


        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer" 
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
        mdiEye,
        mdiEyeOff,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer, 
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,
            mdiEye: mdiEye,
            mdiEyeOff: mdiEyeOff,

            isLoading: true, 
			item_id : "",
			item: {},
			
			actionDialogShow : false,
			actionDialogText : "",
			actionDialogColor : "",

			showPassword : false,
		}),
		mounted(){
			this.item_id = this.$route.query.id || ""
			this.loadItem() 
		},
        methods: {
			loadItem(){
				this.isLoading = true;
				if(this.item_id == ""){
					this.setNewItemData();
					this.isLoading = false; 
				}else{ 
					this.$http.get( process.env.VUE_APP_API_URL + "/users/info", {
						params : { id : this.item_id }
					}).then(response => {  
						response.body.changePassword = false;
						this.item = response.body; 
						this.isLoading = false; 
					})  
				}
			},
			setNewItemData(){
				this.item = {
					id:"",
					firstname : "",
					lastname : "",
					phone : "",
					email : "",
					password : "",
					changePassword : true,
					company : {
						firma_adi : "",
						firma_adresi : "",
						il : "",
						ilce : "",
						vergi_no : "",
					},
					subusers : [],
					active : true
				}
			},
			addSubuser(before){
				var subuser = {
					firstname : "",
					lastname : "",
					department : "",
					email : "",
					phone : "",
				}
				if(before === 0 || before > 0){
					this.item.subusers.splice(before, 0, subuser);
				}
				else{
					this.item.subusers.push(subuser)
				}
			},
			removeSubuser(i){
				this.item.subusers.splice(i, 1);
			},
            
            saveItem() {
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/users/save", this.item).then(response => {  
					if(response.body.success){
						this.actionDialogShow = true;
						this.actionDialogText = "Kayıt başarılı"
						this.actionDialogColor = "green"
						this.$router.replace("/users/edit/?id="+response.body.id)
						setTimeout(()=>{
							location.reload();
						},500)
					}
					else{
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason
						this.actionDialogColor = "red" 
						this.isLoading = false;
					} 
				}) 
            }, 
        } 
    }
</script>

<style>

</style>